import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-bid-payment.reducer';

export const TenantBidPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantBidPaymentEntity = useAppSelector(state => state.tenantBidPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantBidPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantBidPayment.detail.title">TenantBidPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.id}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.paymentMethod}</dd>
          <dt>
            <span id="transactionDetails">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.transactionDetails">Transaction Details</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.transactionDetails}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.paidAmount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="tmCursor">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.tmCursor">Tm Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.tmCursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.lastUpdated}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.paymentStatus}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedReason">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.voidedReason">Voided Reason</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.voidedReason}</dd>
          <dt>
            <span id="voidedDate">
              <Translate contentKey="tinyMedicRestApp.tenantBidPayment.voidedDate">Voided Date</Translate>
            </span>
          </dt>
          <dd>{tenantBidPaymentEntity.voidedDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantBidPayment.tenantBid">Tenant Bid</Translate>
          </dt>
          <dd>{tenantBidPaymentEntity.tenantBid ? tenantBidPaymentEntity.tenantBid.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-bid-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-bid-payment/${tenantBidPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantBidPaymentDetail;
